import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { IMyOptions } from 'ngx-mydatepicker';
import { Subject } from 'rxjs';

import { AlertType } from '../../../../../domain/enums/alertType';
import { Alert } from '../../../../../domain/models/alert';
import { LimitToPipe } from '../../../../pipes/limit-to.pipe';
import { AlertOverviewService } from '../../services/alert-overview.service';

@Component({
  selector: 'app-add-alert',
  templateUrl: './add-alert.component.html',
  styleUrls: ['./add-alert.component.scss']
})
export class AddAlertComponent implements OnInit {
  @Input() routeId: string;
  @Input() routeName: string;
  @Input() projectName: string;

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  private formLocked: boolean;

  public alertTypes: any[] = [
    { type: AlertType.TravelSpeed, name: 'travel speed', translateTag: 'TRAVELSPEED' },
    { type: AlertType.TravelTime, name: 'travel time', translateTag: 'TRAVELTIME' },
  ];
  private myOptions: IMyOptions;

  public time: any = { startHour: 0, startMinutes: 0, endHour: 23, endMinutes: 59 };
  public selectedType: any;
  public threshold: any;
  public durationSelected: boolean;
  public repeatSelected: boolean;
  public webAlertsEnabled: boolean;
  public alerts: Alert[];
  public duration: number;
  public repeat: number;
  public emails: string[];

  private timeInputObservable: Subject<any>;
  private startTimeString: string;
  private endTimeString: string;

  private startDate: Date;
  private endDate: Date;
  private fromDatePicker: any;
  private toDatePicker: any;
  private timeZoneId: string;

  constructor(private alertOverviewService: AlertOverviewService, private translateService: TranslateService) { }

  ngOnInit() {
    this.setDatePickerOptions();
    this.formLocked = false;
    this.startDate = null;
    this.endDate = null;
    this.emails = [];
    this.webAlertsEnabled = false;
    this.startTimeString = '00:00:00';
    this.endTimeString = '23:59:59';
    if (this.fromDatePicker && this.fromDatePicker.jsdate) {
      this.startDate = this.fromDatePicker.jsdate;
    }
    if (this.toDatePicker && this.toDatePicker.jsdate) {
      this.endDate = this.toDatePicker.jsdate;
    }
    this.timeInputObservable = new Subject<any>();
    this.getTimeZoneForJob();

    this.translateService.onLangChange.subscribe(() => {
      this.setDatePickerOptions();
    });
  }

  setDatePickerOptions(): void {
    this.myOptions = {
      dateFormat: 'dd/mm/yyyy',
      dayLabels: {
        su: new LimitToPipe().transform(this.translateService.instant('SUNDAY'), 3),
        mo: new LimitToPipe().transform(this.translateService.instant('MONDAY'), 3),
        tu: new LimitToPipe().transform(this.translateService.instant('TUESDAY'), 3),
        we: new LimitToPipe().transform(this.translateService.instant('WEDNESDAY'), 3),
        th: new LimitToPipe().transform(this.translateService.instant('THURSDAY'), 3),
        fr: new LimitToPipe().transform(this.translateService.instant('FRIDAY'), 3),
        sa: new LimitToPipe().transform(this.translateService.instant('SATURDAY'), 3)
      },
      monthLabels: {
        1: new LimitToPipe().transform(this.translateService.instant('JANUARY'), 3),
        2: new LimitToPipe().transform(this.translateService.instant('FEBRUARY'), 3),
        3: new LimitToPipe().transform(this.translateService.instant('MARCH'), 3),
        4: new LimitToPipe().transform(this.translateService.instant('APRIL'), 3),
        5: new LimitToPipe().transform(this.translateService.instant('MAY'), 3),
        6: new LimitToPipe().transform(this.translateService.instant('JUNE'), 3),
        7: new LimitToPipe().transform(this.translateService.instant('JULY'), 3),
        8: new LimitToPipe().transform(this.translateService.instant('AUGUST'), 3),
        9: new LimitToPipe().transform(this.translateService.instant('SEPTEMBER'), 3),
        10: new LimitToPipe().transform(this.translateService.instant('OCTOBER'), 3),
        11: new LimitToPipe().transform(this.translateService.instant('NOVEMBER'), 3),
        12: new LimitToPipe().transform(this.translateService.instant('DECEMBER'), 3)
      },
      todayBtnTxt: this.translateService.instant('TODAY')
    };
  }

  getTimeZoneForJob(): void {
    this.alertOverviewService.getTimeZoneForJob(this.routeId)
      .subscribe((timezone: string) => {
        this.timeZoneId = timezone;
      });
  }

  addAlert(): void {
    let alert = new Alert();
    alert.start = this.startDate;
    alert.end = this.endDate;
    alert.startTime = this.startTimeString;
    alert.endTime = this.endTimeString;
    alert.jobId = this.routeId;
    alert.jobName = this.routeName;
    alert.threshold = this.threshold;
    alert.type = this.selectedType.type;
    alert.timeZoneId = this.timeZoneId;
    alert.webAlertsEnabled = this.webAlertsEnabled;
    alert.language = this.translateService.currentLang;

    if (this.repeatSelected) {
      alert.repeat = this.repeat;
    }
    if (this.durationSelected) {
      alert.minDuration = this.duration;
    }
    alert.recipients = this.emails;

    this.alertOverviewService.createAlert(alert).subscribe(() => this.confirmAlert());
  }

  alertTypeChanged(): void {
  }

  onStartDateChanged(event: any): void {
    this.startDate = event.jsdate;
    this.startDate.setHours(0, 0, 0);
  }
  onEndDateChanged(event: any): void {
    this.endDate = event.jsdate;
    this.endDate.setHours(23, 59, 59);
  }

  timeChanged(newTime: any): void {
    this.time = newTime;
    let sHour: string = newTime.startHour < 10 && newTime.startHour !== '00' ? '0' + newTime.startHour : newTime.startHour;
    let sMinutes: string = newTime.startMinutes < 10 && newTime.startMinutes !== '00' ? '0' + newTime.startMinutes : newTime.startMinutes;
    let eHour: string = newTime.endHour < 10 && newTime.endHour !== '00' ? '0' + newTime.endHour : newTime.endHour;
    let eMinutes: string = newTime.endMinutes < 10 && newTime.endMinutes !== '00' ? '0' + newTime.endMinutes : newTime.endMinutes;

    this.startTimeString = sHour + ':' + sMinutes + ':00';
    this.endTimeString = eHour + ':' + eMinutes + ':00';
  }

  getType(type: number): string {
    if (type === 0) {
      return 'TRAVELTIME';
    } else {
      return 'TRAVELSPEED';
    }
  }

  confirmAlert(): void {
    if (!this.formLocked) {
      this.formLocked = true;
      this.onConfirm.emit();
    }
  }

  closeWindow(): void {
    this.onCancel.emit();
  }

  isTimeSelected(): boolean {
    return this.selectedType === undefined || this.selectedType.type === AlertType.TravelTime;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/alert-overview/components/add-alert/add-alert.component.ts